import clsx from 'clsx';
import { toAbsoluteUrl, truncateStringInMiddle } from '../../../../../../_metronic/helpers';
import CopyTextButton from '../../../../../modules/components/copyText/CopyTextButton';

interface Props {
  url: string;
  label?: React.ReactNode;
  thumbnail?: string;
  onClickThumbnail?: () => void;
  showThumbnaiPlaceholder?: boolean;
  thumbnailSize?: number;
  className?: {
    container?: string;
    thumbnailContainer?: string;
    label?: string;
  };
}

export default function UrlLabelThumbnailCard({
  url,
  label,
  thumbnail,
  onClickThumbnail,
  showThumbnaiPlaceholder,
  thumbnailSize = 40, // px
  className,
}: Props) {
  const urlContainerMaxWidth = {
    normal: 1500, // px
    print: 700,
  };

  return (
    <div className={clsx('d-flex gap-4', className?.container)}>
      {thumbnail && (
        <div
          onClick={(e) => {
            e.stopPropagation();
          }}
          className={className?.thumbnailContainer}
          style={{
            height: `${thumbnailSize}px`,
            width: `${thumbnailSize}px`,
          }}
        >
          <div className='overlay d-inline-block h-100 w-100'>
            <div className='overlay-wrapper h-100 w-100'>
              <img
                src={thumbnail}
                className='rounded-1 h-100 w-100'
                style={{
                  objectFit: 'cover',
                }}
                loading='lazy'
              />
            </div>
            <div
              className='overlay-layer bg-dark bg-opacity-50 rounded-1'
              onClick={onClickThumbnail}
              title='View image'
            >
              <i className='fas fa-eye text-white fs-3'></i>
            </div>
          </div>
        </div>
      )}
      {!thumbnail && showThumbnaiPlaceholder && (
        <div
          style={{
            height: `${thumbnailSize}px`,
            width: `${thumbnailSize}px`,
          }}
          className={clsx(
            'rounded-1 bg-gray-200 d-flex align-items-center justify-content-center',
            className?.thumbnailContainer
          )}
        >
          <img
            src={toAbsoluteUrl('/media/icons/duotune/general/gen006.svg')}
            alt='No image'
            loading='lazy'
          />
        </div>
      )}

      <div className='vstack justify-content-center text-start'>
        {label && <span className={className?.label}>{label}</span>}
        <span
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <a
            href={url}
            target='_blank'
            rel='noopener noreferrer'
            title={url}
            className='fs-7 text-break'
            style={{ width: 'fit-content' }}
          >
            <span className='d-print-block d-none'>
              {truncateStringInMiddle(url, urlContainerMaxWidth.print)}
            </span>
            <span className='d-print-none'>
              {truncateStringInMiddle(url, urlContainerMaxWidth.normal)}
            </span>
          </a>
          <CopyTextButton text={url} />
        </span>
      </div>
    </div>
  );
}
